export default __webpack_public_path__ + "static/media/Bibimbap.230ca0c5.svg";